import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { Box } from '@mui/material';
import Stack from '@mui/material/Stack';
import { StructureCheck } from '@/components/shared/StructureCheck';
import { SideDrawer } from '@/components/shared/SideDrawer';
import { GlobalSnackbar } from '@/components/shared/Snackbar/GlobalSnackbar';
import { AccessGuard } from '../shared/AccessGuard';
import * as globalState from '@/state';
import { Container, ParentContainer, Wrapper } from './styles';
import { CadAlignmentData } from './CadAlignmentData';
import { LeftToolbar } from './components/LeftToolbar';
import { TopToolbar } from './TopToolbar';

type Props = {
  structureId: string;
};
export const CadModelAlignment = ({ structureId }: Props) => {
  const leftDrawerSize = 300;

  const setEnableAdaptivePointBudget = useSetAtom(globalState.enableAdaptivePointBudget);
  const setPointBudget = useSetAtom(globalState.pointBudget);

  useEffect(() => {
    setEnableAdaptivePointBudget(false);
    setPointBudget(10_000_000);
  }, [setEnableAdaptivePointBudget, setPointBudget]);

  return (
    <Wrapper>
      <Container>
        <Box sx={{ overflow: 'auto', height: '100%' }}>
          <StructureCheck structureId={structureId}>
            <>
              <Box>
                <SideDrawer
                  isOpen={true}
                  handleOpen={() => {}}
                  position="left"
                  width={leftDrawerSize}
                >
                  <LeftToolbar structureId={structureId} />
                </SideDrawer>
              </Box>
              <Stack
                direction="column"
                spacing={0}
                alignItems="stretch"
                sx={{
                  marginLeft: `${leftDrawerSize}px`,
                }}
              >
                <ParentContainer navbarHeight={0}>
                  <Container>
                    {/* <AccessGuard structureId={structureId} feature="cadAlignment"> */}
                    <AccessGuard structureId={structureId} feature="viewer">
                      <TopToolbar />
                      <CadAlignmentData structureId={structureId} />
                    </AccessGuard>
                  </Container>
                </ParentContainer>
              </Stack>
            </>
          </StructureCheck>
        </Box>
        <GlobalSnackbar />
      </Container>
    </Wrapper>
  );
};
